import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { HubHeader, HubFooter } from "../components/HubChrome";
import { useSeo } from "../lib/seo";
import { blog } from "../seo/schema";

export const PostCard = ({ post, i = 0 }) => (
  <Link
    to={`/blog/${post.slug}`}
    data-testid={`blog-card-${post.slug}`}
    className="group flex flex-col bg-[#111111] border border-white/10 rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300 animate-[fadeIn_0.6s_ease-out_both]"
    style={{ animationDelay: `${i * 100}ms` }}
  >
    <div className="relative aspect-[16/9] overflow-hidden">
      <img src={post.cover} alt={post.coverAlt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <span className="absolute top-4 left-4 bg-[#E50914] text-white font-cond uppercase text-[10px] tracking-widest rounded-full px-3 py-1">{post.kicker}</span>
    </div>
    <div className="p-6 flex flex-col flex-1">
      <h2 className="font-cond font-bold uppercase text-white text-xl leading-snug">{post.title}</h2>
      <p className="mt-3 text-white/60 text-sm leading-relaxed flex-1">{post.description}</p>
      <span className="mt-5 inline-flex items-center gap-2 font-cond uppercase tracking-widest text-sm text-[#E50914] group-hover:gap-3 transition-all">
        Read the post <ArrowRight size={16} />
      </span>
    </div>
  </Link>
);

export default function Blog() {
  useSeo("/blog");
  return (
    <div className="bg-[#0A0A0A] min-h-screen text-white" data-testid="blog-index-page">
      <HubHeader />
      <main className="max-w-7xl mx-auto px-5 py-16 sm:py-20">
        <p className="font-cond uppercase tracking-[0.4em] text-[#E50914] text-sm mb-3">Stories &amp; Sailing Guides</p>
        <h1 data-testid="blog-h1" className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-none">
          The House Heads <span className="text-[#E50914]">At Sea</span> Blog
        </h1>
        <p className="mt-5 text-white/65 max-w-2xl">{blog.index.intro}</p>
        <div className="mt-12 grid sm:grid-cols-2 gap-6">
          {blog.posts.map((p, i) => <PostCard key={p.slug} post={p} i={i} />)}
        </div>
      </main>
      <HubFooter />
    </div>
  );
}
